import React, { useCallback } from "react";

import { ErrorMessage, Field } from "formik";
import { Calendar } from "react-date-range";
import { ptBR } from "date-fns/locale";
import TextError from "./TextError";
import "react-date-range/dist/styles.css";
import "./calendar.css";
import { formattedDate } from "../../utils/date";
const OutlineCalendar = ({
  name,
  value,
  onChange,
  label,
  availableDays,
  ...rest
}) => {
  const formatDate = useCallback((date) => {
    return formattedDate(date);
  }, []);

  return (
    <div className="form-control">
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          const { value } = field;
          return (
            <div>
              <label>{label && label}</label>
              <Calendar
                {...field}
                {...rest}
                id={name}
                date={value}
                color="#68A300"
                locale={ptBR}
                disabledDay={(date) => {
                  const checkedDate = formatDate(date);
                  return !availableDays.includes(checkedDate);
                }}
                dateDisplayFormat="dd/MM/yyyy"
                onChange={(date) => {
                  setFieldValue(name, date);
                  if (onChange) return onChange(date);
                }}
                value={value}
              />
            </div>
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
};

export default OutlineCalendar;
